<template>
    <section id="nav-section" class="container">
        <nav class="navbar" role="navigation" aria-label="main navigation">
            <div class="navbar-brand">
                <span class="navbar-item">
                    <h2 class="text-grey-400 pr-8">
                        <slot></slot>
                    </h2>
                </span>
                <a
                    role="button"
                    class="navbar-burger"
                    aria-label="menu"
                    aria-expanded="false"
                    @click="toggleNavBar"
                >
                    <span aria-hidden="true"></span>
                    <span aria-hidden="true"></span>
                    <span aria-hidden="true"></span>
                </a>
            </div>
            <div class="navbar-menu" :class="menuClass">
                <div class="navbar-start">
                    <a
                        class="navbar-item"
                        data-scroll
                        href="#featured-section"
                        @click="closeNavBar"
                    >
                        Features
                    </a>
                    <a
                        class="navbar-item"
                        data-scroll
                        href="#description-section"
                        @click="closeNavBar"
                    >
                        Description
                    </a>
                    <a
                        class="navbar-item"
                        data-scroll
                        href="#gallery-section"
                        @click="closeNavBar"
                    >
                        Gallery
                    </a>
                    <a
                        class="navbar-item"
                        data-scroll
                        href="#videos-section"
                        @click="closeNavBar"
                        v-if="videos"
                    >
                        Videos
                    </a>
                    <a
                        class="navbar-item"
                        v-if="hasOpenHouse"
                        data-scroll
                        href="#openhouse-section"
                        @click="closeNavBar"
                    >
                        Open House
                    </a>
                    <a
                        class="navbar-item"
                        data-scroll
                        href="#contact-section"
                        @click="closeNavBar"
                    >
                        Contact
                    </a>
                </div>
                <div class="navbar-end" v-if="showform">
                    <div class="navbar-item">
                        <div class="buttons">
                            <a
                                class="button is-primary schedule-for-showing"
                                @click="openSignupModal"
                            >
                                <strong>Schedule for Showing</strong>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </nav>
    </section>
</template>
<script>
export default {
    props: ["property", "videos", "showform", "tagLine"],
    methods: {
        closeNavBar() {
            $(".navbar-menu").removeClass("is-active");
        },
        toggleNavBar() {
            $(".navbar-menu").toggleClass("is-active");
        },
        gaTrack() {
            gtag("event", "click", {
                hitType: "event",
                eventCategory: "Property Button Click",
                eventAction: "schedule-for-showing",
                eventLabel: "Schedule for showing"
            });
        },
        openSignupModal() {
            //this.$emit("show-signup");
            this.$modal.show("signup-modal");
            this.gTrack();
        }
    },
    computed: {
        hasOpenHouse() {
            return this.property.openhouse == "1" &&
                this.property.openhouses.length
                ? true
                : false;
        }
    },
    data() {
        return {
            menuClass: ""
        };
    }
};
</script>
